// src/pages/Admin/Business/Finance/charts/CommitmentsStatusDonut.jsx

import React from "react";
import {
  Cell,
  Pie,
  PieChart,
  ResponsiveContainer,
  Tooltip,
} from "recharts";

const CommitmentsStatusDonut = ({ data = [] }) => {
  if (!data.length) {
    return (
      <div className="grid h-[260px] place-items-center text-sm text-slate-400 dark:text-slate-500">
        Aucune donnée disponible.
      </div>
    );
  }

  return (
    <div className="h-[260px] w-full">
      <ResponsiveContainer width="100%" height="100%">
        <PieChart>
          <Pie
            data={data}
            dataKey="value"
            nameKey="name"
            innerRadius={65}
            outerRadius={95}
            paddingAngle={3}
          >
            {data.map((entry) => (
              <Cell key={entry.name} fill={entry.color} />
            ))}
          </Pie>

          <Tooltip
            formatter={(value, name) => [`${value}`, name]}
            contentStyle={{
              borderRadius: 16,
              border: "1px solid rgba(148,163,184,0.2)",
            }}
          />
        </PieChart>
      </ResponsiveContainer>

      <div className="mt-4 flex flex-wrap gap-2">
        {data.map((entry) => (
          <div
            key={entry.name}
            className="inline-flex items-center gap-2 rounded-full bg-slate-100 px-3 py-1.5 text-xs font-medium text-slate-700 dark:bg-slate-800 dark:text-slate-200"
          >
            <span
              className="h-2.5 w-2.5 rounded-full"
              style={{ backgroundColor: entry.color }}
            />
            {entry.name} • {entry.value}
          </div>
        ))}
      </div>
    </div>
  );
};

export default CommitmentsStatusDonut;